<mat-select class="language-selector" [ngModel]="selectedLocaleCode$ | async" (ngModelChange)="changeLanguage($event)">
  <mat-select-trigger>
    <mat-icon inline class='language-selector__icon'>language</mat-icon>
    <span class='language-selector__text'>{{ selectedLanguageName$ | async }}</span>
    
  </mat-select-trigger>
  <mat-option *ngFor="let locale of locales$ | async" [value]="locale.code">
    {{ locale.name }}
  </mat-option>
</mat-select>